import { Button } from '@jeraisonne/ui';

/** Les trois choses à savoir avant de commencer (en gros, une ligne chacune). */
export const GUIDED_INTRO_POINTS = [
  'Ce qui brille en doré, c’est là que tu touches.',
  'Le moteur vérifie chaque ligne que tu écris.',
  'Rien ne bouge tout seul : c’est toi qui appuies.',
] as const;

/**
 * Avant l'exercice guidé de la démo : on prépare l'élève. Il va raisonner pas à pas et se laisser guider — un doigt
 * doré montre où toucher, c'est lui qui appuie. Peu de texte, en gros ; le moteur se charge pendant ce temps.
 */
export function GuidedIntroScreen({
  classLabel,
  onStart,
}: {
  classLabel: string;
  onStart: () => void;
}) {
  return (
    <div className="mx-auto mt-6 max-w-md" data-testid="demo-guided-intro">
      <p className="text-primary-600 text-center text-sm font-bold uppercase tracking-wider">
        {classLabel} · 1 minute
      </p>
      <h1 className="font-display text-ink-900 mt-3 text-center text-[34px] font-extrabold leading-[1.1]">
        Raisonne pas à pas
      </h1>
      <p className="font-display text-primary-600 mt-1 text-center text-2xl font-extrabold">
        Laisse-toi guider
      </p>
      <ol className="mt-8 space-y-4">
        {GUIDED_INTRO_POINTS.map((point, i) => (
          <li key={point} className="flex items-start gap-3">
            <span
              className="bg-primary-500 font-display flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-base font-extrabold text-white"
              aria-hidden
            >
              {i + 1}
            </span>
            <span className="text-ink-900 pt-0.5 text-lg font-semibold leading-snug">{point}</span>
          </li>
        ))}
      </ol>
      <Button size="lg" fullWidth className="mt-10" onClick={onStart}>
        C’est parti
      </Button>
    </div>
  );
}
